import type { ActionResult, Paginated, UserInviteBody, UserListItem } from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

/**
 * Couche réseau de l'écran Utilisateurs (`02` §13). Clés de requête locales à
 * cette fonctionnalité (pas d'ajout à `lib/query/keys.ts`, hors périmètre de
 * cette vague — voir `README-shell.md`).
 */
export const usersQueryKeys = {
  all: ['users'] as const,
  list: (params: UsersListParams) => ['users', 'list', params] as const,
};

export interface UsersListParams {
  page: number;
  pageSize: number;
  sortDir: 'asc' | 'desc';
  sortBy?: string;
}

export function fetchUsersList(params: UsersListParams): Promise<Paginated<UserListItem>> {
  return apiFetch<Paginated<UserListItem>>('/api/users', {
    query: {
      page: params.page,
      pageSize: params.pageSize,
      sortDir: params.sortDir,
      ...(params.sortBy ? { sortBy: params.sortBy } : {}),
    },
  });
}

/** `POST /api/users` — `02` §13 : « inviter (email + nom → email d'invitation) ». */
export function inviteUser(body: UserInviteBody): Promise<UserListItem> {
  return apiFetch<UserListItem>('/api/users', { method: 'POST', body });
}

/**
 * `DELETE /api/users/:id` — `02` §13 : « supprimer (confirmation) ». Le
 * serveur renvoie 409 (message exact à afficher tel quel) quand `id` est le
 * dernier compte restant, voir `apps/server/.../users/service.ts::deleteUser`.
 */
export function deleteUser(id: string): Promise<ActionResult> {
  return apiFetch<ActionResult>(`/api/users/${id}`, { method: 'DELETE' });
}

/** `POST /api/users/:id/resend-invitation` — `02` §13 : « renvoyer l'invitation ». */
export function resendInvitation(id: string): Promise<ActionResult> {
  return apiFetch<ActionResult>(`/api/users/${id}/resend-invitation`, { method: 'POST' });
}
